import React from "react";
import Layout from "../components/layout";

const PrivacyPolicy = () => {
  return (
    <Layout>
    <div className="p-6 max-w-5xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">Effective Date: 01 June 2025</p>

      <p className="mb-4">
        Fix Labs Private Limited ("VIBE","Fix Labs", "we", "us", or "our") is committed
        to protecting your privacy. This Privacy Policy explains how we collect,
        use, disclose, and safeguard your information when you use our services,
        including our website, applications, and any other services that link to
        this policy (collectively, the "Services").
      </p>
      <p className="mb-4">
         VIBE is a WhatsApp Business CRM tool that is powered by Fix Labs Private limited. The product provides a “Conversation Cloud Platform” with WhatsApp Business that allows our Customers to store, manipulate, analyze and transfer messages between their business systems and their customers on a variety of VIBE-provided and third-party messaging channels (the “Service”).
         VIBE is committed to the protection of Personal Data, including data that we use for our own purposes, and that we maintain on behalf of our Clients.
      </p>
      <p className="mb-4">
        By accessing or using our Services, you consent to the practices described
        in this Privacy Policy.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
      <p className="mb-2 font-semibold">a. Personal Data</p>
      <ul className="list-disc pl-6 mb-4">
        <li>Full name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Business name and details</li>
        <li>Payment information</li>
        <li>Any other information you provide directly to us</li>
      </ul>

      <p className="mb-2 font-semibold">b. Usage Data</p>
      <ul className="list-disc pl-6 mb-4">
        <li>IP address</li>
        <li>Browser type and version</li>
        <li>Device information</li>
        <li>Pages visited and time spent</li>
        <li>Clickstream data</li>
      </ul>

      <p className="mb-2 font-semibold">c. Cookies and Tracking Technologies</p>
      <p className="mb-4">
        We use cookies and similar tracking technologies to enhance your experience.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>To provide, operate, and maintain our Services</li>
        <li>To improve and personalize user experience</li>
        <li>To develop new products and features</li>
        <li>To communicate with you</li>
        <li>To process transactions</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">3. Sharing Your Information</h2>
      <p className="mb-4">
        We may share your information with service providers, in business
        transfers, and if required by law. All parties are bound by confidentiality
        agreements.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Data Retention</h2>
      <p className="mb-4">
        We retain your personal data only as long as necessary for the purposes
        outlined in this policy.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Data Security</h2>
      <p className="mb-4">
        We implement industry-standard measures such as encryption, access
        controls, and security assessments to protect your data.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. Your Rights</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Access</li>
        <li>Correction</li>
        <li>Deletion</li>
        <li>Objection</li>
        <li>Restriction</li>
        <li>Data Portability</li>
      </ul>
      <p className="mb-4">To exercise any of these rights, please contact us at support@fixlabs.ai</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. Children’s Privacy</h2>
      <p className="mb-4">
        Our Services are not intended for individuals under 16. We do not knowingly
        collect personal data from children.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">8. International Transfers</h2>
      <p className="mb-4">
        Your data may be stored and processed in countries outside your own. We
        ensure such transfers are compliant with applicable laws.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">9. Changes to This Policy</h2>
      <p className="mb-4">
        We may update this policy from time to time. Revisions will be posted on
        this page with an updated effective date.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">10. Contact Us</h2>
      <p>
        Fix Labs Private Limited<br />
        WeWork, Eldeco Center, New Delhi - 110017<br />
        Email: support@fixlabs.ai
      </p>
    </div>
  </Layout>
  );
};

export default PrivacyPolicy;
